import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}

export function formatDateTime(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

export function formatRelativeTime(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = date - now;
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    
    if (diffInDays < 0) {
        const absDays = Math.abs(diffInDays);
        if (absDays === 1) return '1 day ago';
        return `${absDays} days ago`;
    } else if (diffInDays === 0) {
        return 'Today';
    } else if (diffInDays === 1) {
        return 'Tomorrow';
    } else if (diffInDays <= 7) {
        return `In ${diffInDays} days`;
    } else {
        return formatDate(dateString);
    }
}

export function getStatusColor(status) {
    const colors = {
        'pending': 'status-pending',
        'in-progress': 'status-in-progress',
        'completed': 'status-completed',
        'cancelled': 'status-critical',
        'active': 'status-completed',
        'inactive': 'status-pending',
        'maintenance': 'status-in-progress',
        'decommissioned': 'status-critical'
    };
    return colors[status] || 'status-pending';
}

export function getPriorityColor(priority) {
    const colors = {
        'low': 'priority-low',
        'medium': 'priority-medium',
        'high': 'priority-high',
        'critical': 'priority-critical'
    };
    return colors[priority] || 'priority-medium';
}

export function capitalizeFirst(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).replace(/-/g, ' ');
}
